import React from 'react';
import { Card, Gradient } from '../../../Global/styles';
import { NavLink } from 'react-router-dom';
import { checkImage } from '../../../componentUtils';
import { ITrail } from '../../../../models/interfaces/ITrail';
import { CardTitleContainer } from './carouselStyles';
import { v4 } from 'uuid';
import LoadingImage from '../../../Global/LoadingImage/LoadingImage';
import { TrailHelper } from '../../../../models/helpers/Helpers';
import BookmarkTrailButton from '../../../Global/BookmarkButton/BookmarkTrailButton';
import { Trail } from '../../../../models/Trail';
import ActivityIcon from './ActivityIcon';
import { shallowEqual } from 'react-redux';
import { useAppSelector } from '../../../../state/hooks';
import { RootState } from '../../../../state/store';
import { PrefsPayload, prefsInitialState } from '../../../../state/prefsSlice';

type CarouselItemProps = {
	item: Trail;
};

const CarouselItem: React.FC<CarouselItemProps> = ({ item }) => {
	const activities = item.activities;
	const user_prefs = useAppSelector(
		(state: RootState) =>
			(state.prefs as PrefsPayload | undefined) ?? prefsInitialState,
		shallowEqual,
	);
	if (item.id !== undefined) {
		return (
			<>
				<Card $height={360}>
					<NavLink to={'/trail/' + item.id}>
						<LoadingImage src={checkImage(item.image)} />
						<Gradient />

						<CardTitleContainer>
							{/* TODO: Format this and add icons? */}
							{activities &&
								activities.map((activity) => {
									return (
										<ActivityIcon
											key={v4()}
											activity={activity}
										/>
									);
								})}
							<h3>{item.title}</h3>
							<p>
								{TrailHelper.generateMetaString(
									item,
									user_prefs.preferred_dist_units ?? 'km',
								)}
							</p>
						</CardTitleContainer>
					</NavLink>
					<BookmarkTrailButton trailId={item.id} />
				</Card>
			</>
		);
	} else {
		return <></>;
	}
};

export default CarouselItem;
